import {
  CommunicationStatus,
  ResponseRejectionReason,
} from "@/briefpoint-client";
import type { FileExplorerVariant } from "@/lib/types";

export const API_URL: string = import.meta.env.VITE_API_URL;
export const CaliforniaId = "7c635e83-3d84-4b75-a09f-7acbe6c07bf8";
export const NewYorkId = "2edd767c-57ec-4b96-8f1a-5a64ea2ed7e4";
export const FederalId = "6652fce2-272b-4c70-b4a8-9b84642a465f";
export const FamilyLawCaseType = "06aa5433-6ff3-485f-a9f7-38a540916473";

export const GOTENBURG_MIME_TYPES: Record<string, string[]> = {
  "application/epub+zip": [".epub"],
  "application/msword": [".doc", ".dot", ".mcw"],
  "application/pdf": [".pdf"],
  "application/rtf": [".rtf"],
  "application/vnd.apple.keynote": [".key"],
  "application/vnd.apple.numbers": [".numbers"],
  "application/vnd.apple.pages": [".pages"],
  "application/vnd.dbf": [".dbf"],
  "application/vnd.lotus-1-2-3": [".123", ".wk1", ".wks"],
  "application/vnd.lotus-wordpro": [".lwp"],
  "application/vnd.ms-excel": [".xls", ".xlt", ".xlw"],
  "application/vnd.ms-excel.sheet.binary.macroEnabled.12": [".xlsb"],
  "application/vnd.ms-excel.sheet.macroEnabled.12": [".xlsm"],
  "application/vnd.ms-excel.template.macroEnabled.12": [".xltm"],
  "application/vnd.ms-powerpoint": [".ppt", ".pot", ".pps", ".psw"],
  "application/vnd.ms-powerpoint.presentation.macroEnabled.12": [".pptm"],
  "application/vnd.ms-powerpoint.template.macroEnabled.12": [".potm"],
  "application/vnd.ms-works": [".wps"],
  "application/vnd.ms-word.document.macroEnabled.12": [".docm"],
  "application/vnd.ms-word.template.macroEnabled.12": [".dotm"],
  "application/vnd.oasis.opendocument.graphics": [".odg"],
  "application/vnd.oasis.opendocument.graphics-flat-xml": [".fodg"],
  "application/vnd.oasis.opendocument.graphics-template": [".otg"],
  "application/vnd.oasis.opendocument.presentation": [".odp"],
  "application/vnd.oasis.opendocument.presentation-flat-xml": [".fodp"],
  "application/vnd.oasis.opendocument.presentation-template": [".otp"],
  "application/vnd.oasis.opendocument.spreadsheet": [".ods"],
  "application/vnd.oasis.opendocument.spreadsheet-flat-xml": [".fods"],
  "application/vnd.oasis.opendocument.spreadsheet-template": [".ots"],
  "application/vnd.oasis.opendocument.text": [".odt"],
  "application/vnd.oasis.opendocument.text-flat-xml": [".fodt"],
  "application/vnd.oasis.opendocument.text-master": [".odm"],
  "application/vnd.oasis.opendocument.text-template": [".ott"],
  "application/vnd.oasis.opendocument.text-web": [".oth"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    ".pptx",
  ],
  "application/vnd.openxmlformats-officedocument.presentationml.template": [
    ".potx",
  ],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [
    ".xltx",
  ],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": [
    ".dotx",
  ],
  "application/vnd.stardivision.calc": [".sdc"],
  "application/vnd.stardivision.draw": [".sda"],
  "application/vnd.stardivision.impress": [".sdd", ".sdp"],
  "application/vnd.stardivision.math": [".smf", ".svm"],
  "application/vnd.stardivision.writer": [".sdw", ".vor"],
  "application/vnd.stardivision.writer-global": [".sgl", ".sxg"],
  "application/vnd.sun.xml.calc": [".sxc"],
  "application/vnd.sun.xml.calc.template": [".stc"],
  "application/vnd.sun.xml.impress": [".sxi"],
  "application/vnd.sun.xml.impress.template": [".sti"],
  "application/vnd.sun.xml.math": [".sxm"],
  "application/vnd.sun.xml.writer": [".sxw"],
  "application/vnd.sun.xml.writer.template": [".stw"],
  "application/vnd.uoml+xml": [".uot", ".uof"],
  "application/vnd.visio": [".vsd", ".vsdx", ".vsdm", ".vdx"],
  "application/vnd.palm": [".pdb", ".pxl"],
  "application/vnd.quattro-pro": [".wb2"],
  "application/vnd.wordperfect": [".wpd"],
  "application/x-abiword": [".abw", ".zabw"],
  "application/x-appleworks": [".cwk"],
  "application/x-hwp": [".hwp"],
  "application/x-latex": [".ltx"],
  "application/x-mspublisher": [".pub"],
  "application/x-mw": [".mw"],
  "application/x-shockwave-flash": [".swf"],
  "application/x-slk": [".slk"],
  "application/x-t602": [".602"],
  "application/x-ustar": [".uos"],
  "application/zip": [".zip"],
  "image/bmp": [".bmp"],
  "image/gif": [".gif"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/svg+xml": [".svg"],
  "image/tiff": [".tif", ".tiff"],
  "image/x-cmu-raster": [".ras"],
  "image/x-portable-bitmap": [".pbm"],
  "image/x-portable-graymap": [".pgm"],
  "image/x-portable-pixmap": [".ppm"],
  "image/x-xbitmap": [".xbm"],
  "image/x-xpixmap": [".xpm"],
  "text/csv": [".csv"],
  "text/html": [".html", ".htm", ".xhtml"],
  "text/plain": [".txt"],
  "text/x-bibtex": [".bib"],
  "text/x-diff": [".dif"],
  "text/xml": [".xml"],
  "application/mathml+xml": [".mml"],
  "application/postscript": [".eps"],
  "application/vnd.adobe.photoshop": [".psd"],
  "application/vnd.coreldraw": [".cdr"],
  "application/vnd.sun.xml.draw": [".sxd", ".std"],
  "image/x-pcx": [".pcx"],
  "image/x-pict": [".pct"],
  "image/x-tga": [".tga"],
  "image/x-wmf": [".wmf"],
  "image/x-emf": [".emf"],
  "image/cgm": [".cgm"],
  "image/x-photo-cd": [".pcd"],
  "application/dxf": [".dxf"],
  "application/x-wpg": [".wpg"],
  "application/x-cmx": [".cmx"],
};

export const SHARE_SITES = {
  GOOGLE: "Google",
  ICAL: "iCal",
  OUTLOOK: "Outlook",
};

export const ADD_POSITION = {
  END: "end",
  START: "start",
};

export const PETITIONER_AND_RESPONDENT_TYPES = {
  PLAINTIFF: "Plaintiff",
  DEFENDANT: "Defendant",
  PETITIONER: "Petitioner",
  RESPONDENT: "Respondent",
  CROSS_DEFENDANT: "Cross-Defendant",
  CROSS_RESPONDENT: "Cross-Respondent",
  CROSS_COMPLAINANT: "Cross-Complainant",
  CROSS_PETITIONER: "Cross-Petitioner",
  PETITIONER_AND_RESPONDENT: "Petitioner/Respondent",
  PLAINTIFF_AND_DEFENDANT: "Plaintiff/Defendant",
};

export const PARTY_SPECIFIC_TAGS = [
  "Business",
  "Care Provider",
  "Debtor",
  "Driver",
  "Employer",
  "Government",
  "Insurance Company",
  "Landlord",
  "Manufacturer",
  "Owner",
  "Professional",
  "Tenant",
  "Officer",
  "Expert",
  "Witness",
  "Third Party",
  "Bank",
  "Broker",
  "Real Estate Agent",
];

export const SEARCH_PARAMS = {
  LABEL: {
    TAB: "tab",
    SUB_TAB: "sub_tab",
    PRODUCE: "produce",
    WITHHELD: "withheld",
  },
  RESPONSE_TO_DISCOVERY: "respond_to_discovery",
  PROPOUND_DISCOVERY: "propound_discovery",
  UPLOAD_PRODUCTION: "upload_production",
  PRODUCTION: "production",
  WITHHELD_SEARCH: "withheld_search",
  SEARCH: "search",
  FILTER: "filter",
  INTERROGATORY_ID: "interrogatoryId",
  COLLECT_FROM_CLIENT: "collect_from_client",
  AUTO_OBJECT_PENDING: "auto_object_pending",
  SHOW_SIGN_UP_MODAL: "show_sign_up",
};

export const FILE_EXPLORER_VARIANTS: Record<string, FileExplorerVariant> = {
  WIZARD: "wizard",
  CASE: "case",
};

export const PRODUCE_DOCUMENTS_OBJECTION_ID = 21;

export const UNABLE_TO_PRODUCE_OBJECTION_ID = 22;

/** labels as displayed to the user */
export const RESPONSE_REJECTION_REASON_LABELS: Record<
  ResponseRejectionReason,
  string
> = {
  [ResponseRejectionReason.NeverExisted]: "They never existed",
  [ResponseRejectionReason.Stolen]: "They were Stolen",
  [ResponseRejectionReason.NoLongerInPossession]: "I don't have them anymore",
  [ResponseRejectionReason.NeverInPossession]: "I never had them",
  [ResponseRejectionReason.Destroyed]: "They were destroyed",
  [ResponseRejectionReason.Lost]: "They were lost",
  [ResponseRejectionReason.Unknown]: "Other",
};

/** variant names as stored in the API (for objection variant lookup by name) */
export const RESPONSE_REJECTION_REASON_VARIANT_NAMES: Record<
  ResponseRejectionReason,
  string
> = {
  [ResponseRejectionReason.NeverExisted]: "Never existed",
  [ResponseRejectionReason.Stolen]: "Stolen",
  [ResponseRejectionReason.NoLongerInPossession]: "No longer in possession",
  [ResponseRejectionReason.NeverInPossession]: "Never in possession",
  [ResponseRejectionReason.Destroyed]: "Destroyed",
  [ResponseRejectionReason.Lost]: "Lost",
  [ResponseRejectionReason.Unknown]: "Unknown",
};

export const RESPONSIVE_FILE_ITEM_CHECKBOX = "responsive-file-item-checkbox";
export const NO_CASE_TEXT = "All";

export const ACCEPTED_MIME_TYPES: Record<string, string[]> = {
  ...GOTENBURG_MIME_TYPES,
};

export const ACCEPTED_FILE_TYPES = Object.entries(ACCEPTED_MIME_TYPES)
  .map(([mimeType, extensions]) => `${mimeType},${extensions.join(",")}`)
  .join(",");

export const SHOW_REMINDER_EMAIL_STATUSES = [
  CommunicationStatus.Sent,
  CommunicationStatus.InProgress,
  CommunicationStatus.Open,
];

export const HAS_SEEN_SIGN_UP_MODAL_STORAGE_KEY = "hasSeenSignUpModal";

export const COLLAPSED_ASSOCIATED_OBJECTS_TO_SHOW = 3;

/* Remove autocomplete from form inputs
 * Chrome extensions like 1Password, LastPass and Dashlane can cause inputs to do some strange things so we need to disable autocomplete for these
 */
export const REMOVE_AUTO_COMPLETE = {
  autoComplete: "off",
  "data-1p-ignore": "true",
  "data-bw-ignore": "true",
  "data-lp-ignore": "true",
  "data-form-type": "other",
};
